import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Landing from "@/pages/Landing";
import LegalPage from "@/pages/LegalPage";
import ClarifierPage from "@/pages/ClarifierPage";
import NotFoundPage from "@/pages/NotFoundPage";
import { CookieBanner } from "@/components/okaia/CookieBanner";
import { BackToTop } from "@/components/okaia/BackToTop";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/clarifier-mon-besoin" element={<ClarifierPage />} />
          <Route path="/mentions-legales" element={<LegalPage type="mentions" />} />
          <Route path="/confidentialite" element={<LegalPage type="confidentialite" />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <CookieBanner />
        <BackToTop />
      </BrowserRouter>
    </div>
  );
}

export default App;
